import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from "@angular/router";
import {DataformService} from "../../services/dataform.service";
import {LanguageService} from "../../shared/language/language.service";
import {SharedComponentsService} from "../../services/sharedComponents.service";

@Component({
  selector: 'app-components',
  templateUrl: './components.component.html',
  styleUrls: ['./components.component.css'],
  standalone: false
})
export class ComponentsComponent implements OnInit {

  public projectId: any;
  public readonly!: boolean;
  public idTareaWf: any;
  public process!: string;

  language: string = 'IN'
  username: string = '';
  validUser = false;

  activeTab = 'task-comp';

  constructor(private readonly router: Router,
              private readonly activatedRoute: ActivatedRoute,
              private readonly dataFormService: DataformService,
              private readonly languageService: LanguageService,
              private readonly sharedComponentsService: SharedComponentsService,
  ) {
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.projectId = params['idproy'];
      this.idTareaWf = params['idtareawf'] ? params['idtareawf'] : -1;
      if (this.idTareaWf == -1) {
        this.process = 'PROJECTS'
        this.activeTab = 'all-comp';
      } else {
        this.process = 'TASK'
      }
      let email = atob(params['email']);
      this.language = params['lang'];
      this.readonly = params['readonly'] == 'true';

      localStorage.setItem('email', email);
      this.languageService.setLanguage(params['lang']);
      let paramsT = {
        ac_email: email,
        ac_modulo: 'SOM'
      }
      this.dataFormService.validateAccessUser(paramsT).subscribe((data: any) => {
        if (data.ac_result != 1) {
          this.logout();
        } else {
          this.username = data.ac_usuario;
          localStorage.setItem('username', data.ac_usuario);
          this.validUser = true;
        }
      });
    });

    this.validateActiveTab();
  }

  validateActiveTab() {
    this.sharedComponentsService.currentTaskComponents.subscribe({
      next: (data) => {
        if (data.length == 0) {
          this.activeTab = 'all-comp';
        } else {
          this.activeTab = 'task-comp';
        }
      }
    })
  }


  private logout() {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['/noauthorized']);
  }
}
